import { hotRanking } from "@/mocks/comics";

const riseIcon = (r: number) => {
  if (r > 0) return { icon: "ri-arrow-up-line", color: "text-accent-600" };
  if (r < 0) return { icon: "ri-arrow-down-line", color: "text-foreground-400" };
  return { icon: "ri-subtract-line", color: "text-foreground-400" };
};

const medal = ["bg-secondary-500", "bg-foreground-500", "bg-primary-700"];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-800 px-3 py-1 text-xs">
              <i className="ri-trophy-line"></i>每周热榜
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">热门追更榜</h2>
            <p className="mt-2 text-sm text-foreground-600">根据追更人数与点击热度实时更新</p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1"><i className="ri-refresh-line"></i>每小时刷新</span>
            <span className="inline-flex items-center gap-1"><i className="ri-calendar-line"></i>2026.08.19</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotRanking.map((item, idx) => {
            const r = riseIcon(item.rise);
            return (
              <article
                key={item.id}
                className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 hover:border-accent-300 transition-colors"
              >
                <span
                  className={`w-10 h-10 shrink-0 rounded-lg flex items-center justify-center font-heading text-lg text-background-50 ${
                    medal[idx] || "bg-background-300 text-foreground-700"
                  }`}
                >
                  {idx + 1}
                </span>
                <div className="w-16 h-20 shrink-0 rounded-md overflow-hidden">
                  <img src={item.cover} alt={`${item.title}热门韩漫`} className="w-full h-full object-top object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium text-sm md:text-base text-foreground-950 truncate">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-600">{item.genre} · 更新至{item.chapter}</p>
                  <div className="mt-1.5 inline-flex items-center gap-1 rounded-full bg-accent-100 text-accent-700 px-2 py-0.5 text-xs">
                    <i className={r.icon}></i>上升 {Math.abs(item.rise)}
                  </div>
                </div>
                <a
                  href="#updates"
                  className="shrink-0 w-9 h-9 rounded-md bg-background-200 text-foreground-700 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  aria-label={`前往${item.title}`}
                >
                  <i className="ri-arrow-right-line"></i>
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}